export const FETCH_QUESTION_TYPES_SUCCEEDED = 'FETCH_QUESTION_TYPES_SUCCEEDED'